"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _landlordReasonConstants = _interopRequireDefault(require("./landlordReasonConstants"));

var _tenantReasonConstants = _interopRequireDefault(require("./tenantReasonConstants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  LANDLORD_REASONS: _landlordReasonConstants.default,
  TENANT_REASONS: _tenantReasonConstants.default
};
exports.default = _default;